var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import { Button } from './../../components/button';
const ActionButton = (props) => {
    const clickedRef = useRef(false);
    const handlePromiseOnOk = (returnValueOfOnOk) => {
        const { closeModal } = props;
        if (!returnValueOfOnOk || !returnValueOfOnOk.then) {
            return;
        }
        returnValueOfOnOk.then((...args) => {
            closeModal(...args);
        }, (e) => {
            // eslint-disable-next-line no-console
            console.error(e);
            clickedRef.current = false;
        });
    };
    const onClick = () => {
        const { actionFn, closeModal } = props;
        if (clickedRef.current) {
            return;
        }
        clickedRef.current = true;
        if (!actionFn) {
            closeModal();
            return;
        }
        let returnValueOfOnOk;
        if (actionFn.length) {
            returnValueOfOnOk = actionFn(closeModal);
            clickedRef.current = false;
        }
        else {
            returnValueOfOnOk = actionFn();
            if (!returnValueOfOnOk) {
                closeModal();
                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };
    const { children } = props, resetProps = __rest(props, ["children"]);
    return (React.createElement(Button, Object.assign({ onClick: onClick }, resetProps), children));
};
export default ActionButton;
